import { inject, injectable } from 'inversify'
import type { ComposeSmsResolverResult, Resolvable } from '@/services/resolvers/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Route } from '@/services/route/types'
import type UserNumbersService from '@/services/domain/user/userNumbersService'

@injectable()
export default class ComposeSmsResolverService implements Resolvable<ComposeSmsResolverResult> {
  constructor(@inject(SERVICE_TYPES.UserNumbersService) protected readonly userNumbersService: UserNumbersService) {}

  public async resolve(_params: unknown, route?: Route, fromRoute?: Route) {
    const userNumbers = this.userNumbersService.findUserNumbersOrFail()
    const canSendSms = this.userNumbersService.canSendSms(userNumbers)

    return {
      showGettingStarted: !canSendSms,
    }
  }
}
